<div class="charts" (click)="openOverlay($event)">
  @if (!(isEmpty$ | async) && options$ | async; as options) {
    @for (option of options; track option) {
      <div
        echarts
        (chartInit)="onChartInit($event)"
        [options]="option"
        [theme]="darkMode ? darkTheme : undefined"
        [class]="chart.chartType + ' chart'"
        [style.height.px]="chart.height"
      ></div>
    }
  }
  @if (isEmpty$ | async) {
    <div>
      <span translate>No Data to display</span>.
      <span translate>MC_Please try to select another period of time</span>
    </div>
  }
</div>
